import {gql} from '@apollo/client'

export const GET_ALL_SIGNATURE_FORMS_API = gql`
  query allSignatureForms(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $status: String
    $name: String
  ) {
    allSignatureForms(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      status: $status
      name: $name
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          id
          name
          description
          status
          user {
            id
            firstName
            lastName
            email
          }
          created
          entriesCount
          signedEntriesCount
        }
      }
    }
  }
`

export const GET_ALL_SIGNATURE_FORMS_ACTIVE = gql`
  query allActiveSignatureForms(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $name: String
  ) {
    allSignatureForms(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      status: "ACTIVE"   # 👈 aquí se fija el status
      name: $name
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          id
          name
          description
          status
          user {
            id
            firstName
            lastName
            email
          }
          created
          entriesCount
          signedEntriesCount
        }
      }
    }
  }
`

export const GET_ONE_SIGNATURE_FORM_API = gql`
  query signatureFormById($id: String) {
    signatureFormById(id: $id) {
      id
      name
      description
      formContent
      emailContent
      smsContent
      status
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`

export const RENDER_SIGNATURE_FORM_PREVIEW = gql`
  query RenderSignatureFormPreview(
    $formId: String!
    $sourceType: String!
    $sourceId: String!
    $agentId: String!
  ) {
    renderSignatureFormPreview(
      formId: $formId
      sourceType: $sourceType
      sourceId: $sourceId
      agentId: $agentId
    ) {
      renderedHtml
    }
  }
`

export const GET_ALL_SIGNATURE_FORMS_LIST = gql`
  query allSignatureForms(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $status: String
    $name: String
  ) {
    allSignatureForms(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      status: $status
      name: $name
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      edges {
        node {
          id
          name
          description
          status
          created
          entriesCount
          signedEntriesCount
        }
      }
    }
  }
`
